// Panel-App
import { App } from "./panel/app.class";
import { Popup } from './panel/popup.class';
import { Switch } from './panel/switch.class';
import { Notificationsmenu } from './panel/notificationsmenu.class';

// Bereiche
import { Page as Page_Login } from './panel/page-login';
import { Page as Page_AccountReset } from './panel/page-account-passreset';
import { Page as Page_AccountResetCode } from './panel/page-account-passreset-code';
import { Page as Page_AccountRegister } from './panel/page-account-register';
import { Page as Page_AccountSetupPassword } from './panel/page-account-setuppassword';
import { Page as Page_Dashboard } from './panel/page-dashboard';
import { Page as Page_Forms } from './panel/page-forms';
import { Page as Page_FormCreate } from './panel/page-form-create';
import { Page as Page_FormOverview } from './panel/page-form-overview';
import { Page as Page_FormSubmissions } from './panel/page-form-submissions';
import { Page as Page_FormSubmission } from './panel/page-form-submission';
import { Page as Page_FormIntegration } from './panel/page-form-integration';
import { Page as Page_FormSettings } from './panel/page-form-settings';
import { Page as Page_FormSpam } from './panel/page-form-spam';
import { Page as Page_Profile } from './panel/page-profile';
import { Page as Page_Membership } from './panel/page-membership';
import { Page as Page_Usage } from './panel/page-usage';
import { Page as Page_App } from './panel/page-app';
import { Page as Page_Privacy } from './panel/page-privacy';
import { Page as Page_FormDelivery } from './panel/page-form-delivery';
import { Page as Page_Mailing } from './panel/form-delivery/mailing';
import { Page as Page_Autoresponse } from './panel/form-delivery/autoresponse';
import { Page as Page_Webhook } from './panel/form-delivery/webhook';
import { Page as Page_Whatsapp } from './panel/form-delivery/whatsapp';
import { Page as Page_CreateEndpoint } from './panel/page-create-endpoint';

// alle Popups initialisieren
App.domready(() => {
    window.Popups = [];
    const popups = document.querySelectorAll(".popup");
    popups.forEach($ele => {
        const p = new Popup($ele, instance => {
            window.Popups.forEach(p => {
                if(p !== instance) {
                    p.close();
                }
            });
        });
        window.Popups.push(p);
    });
});

// alle Switches initialisieren
App.domready(() => {
    const switches = document.querySelectorAll("button.switch");
    switches.forEach($ele => {
        new Switch($ele);
    });
});

// Mobile-Nav in Topbar ein- & ausblenden
App.domready(() => {
    const $containerBtn = document.querySelector(".topbar .mobile-menu");
    if(!$containerBtn) return;
    const $btnOpenNav = $containerBtn.querySelector(".topbar .mobile-menu button");
    const $navArea = document.querySelector("#mobile-menu-display");

    $btnOpenNav.addEventListener("click", event => {
        event.stopPropagation();

        // Schliessen
        if($containerBtn.classList.contains("open")) {
            $containerBtn.classList.remove("open");
            $btnOpenNav.removeAttribute("aria-expanded");
            $navArea.classList.remove("open");
            $navArea.addEventListener('transitionend', e => {
                $navArea.style.display = "none";
            }, { once: true });
        }

        // öffnen
        else {
            $navArea.style.display = "block";
            setTimeout(() => {
                $containerBtn.classList.add("open");
                $btnOpenNav.setAttribute("aria-expanded", true);
                $navArea.classList.add("open");
            }, "1");
        }
    });
});

// Notifications-Menu initialisieren
App.domready(() => {
    new Notificationsmenu();
});

// Seitenwechsel per Select bei Formular-Bereich
App.domready(() => {
    const $select = document.querySelector("#select-form-area");
    if($select) {
        $select.addEventListener("change", event => {
            const value = $select.value;

            // Seite aufrufen
            App.gotoUrl(value);
        });
    }
});

// Matomo
let _paq = window._paq = window._paq || [];
_paq.push(["setDoNotTrack", true], ["disableCookies"], ['trackPageView'], ['enableLinkTracking']);
App.domready(() => {

    const u = "https://matomo.form.taxi/";
    _paq.push(['setTrackerUrl', u+'matomo.php'], ['setSiteId', '1']);

    const $script = document.createElement('script');
    $script.setAttribute('async', true);
    $script.setAttribute('src', u+'matomo.js');

    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore($script, s);
});